import gql from 'graphql-tag';

export const CREATE_EQUIPMENT = gql`
  mutation CreateEquipment($equipment: EquipmentCreateInput) {
    createEquipment(equipment: $equipment) {
      id
      equipmentName
      equipmentModelId
      trackManualHours
      year
      model {
        id
        title
        type
        make {
          id
          title
        }
        category {
          id
          title
        }
      }
      lastHours {
        id
        runningHours
      }
      costHistory {
        id
        machineCostRate
        operatorCostRate
        changeDate
        updatedOn
        deletedOn
      }
      customField1
      customField2
      customField3
      customField4
      customField5
      preOperationChecklistId
      postOperationChecklistId
    }
  }
`;

export const UPDATE_EQUIPMENT = gql`
  mutation UpdateEquipment($equipment: EquipmentUpdateInput) {
    updateEquipment(equipment: $equipment) {
      id
      equipmentName
      equipmentModelId
      trackManualHours
      year
      model {
        id
        title
        type
        make {
          id
          title
        }
        category {
          id
          title
        }
      }
      lastHours {
        id
        runningHours
      }
      costHistory {
        id
        machineCostRate
        operatorCostRate
        changeDate
        updatedOn
        deletedOn
      }
      routines {
        id
        deletedOn
      }
      customField1
      customField2
      customField3
      customField4
      customField5
    }
  }
`;
